import z from "zod";
import { insightHistoryItemSchema } from "./post-ask-insight.schema";

export const postSummarizeInsightSchema = z.object({
	question: z.string().min(1).max(500),
	sql: z.string(),
	data: z.array(z.unknown()),
	history: z.array(insightHistoryItemSchema).max(10).default([]),
});

export type PostSummarizeInsightSchema = z.infer<typeof postSummarizeInsightSchema>;
